import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FileList from "../../../FileList";
import FileUpload from "../../../FileUpload/index";
import { GlobalState } from "../../../../GlobalState";
import Loading from "../../../../util/Loading";
import { ToastContainer, toast } from "react-toastify";
import { createNewSupplier, createNewUser, updateSupplier, updateUser } from "../../../../action";
import { TabTitle } from "../../../../util/titleChanger";
import { api } from "../../../../util/urlConfig";

export default function SupplierForm() {
  const { supplierId } = useParams();
  TabTitle(supplierId > 0 ? "Update Supplier" : "Create Supplier");
  const state = useContext(GlobalState);
  const signInUser = JSON.parse(localStorage.getItem("user_data"));

  //Local state
  const [supplierDetail] = state.supplierAPI.supplierDetail;
  const [id, setId] = state.supplierAPI.id;
  const [callback, setCallback] = state.supplierAPI.callback;
  const [users] = state.userAPI.users;

  const [files, setFiles] = useState([]);
  const [btnName, setBtnName] = useState("Save");
  const [focused, setFocused] = useState(false);
  const [values, setValues] = useState([]);

  const uploadHandler = (file) => {
    if (files.length !== 0) {
      toast.warn("Already uploaded a image!");
    } else {
      if (file) {
        setFiles([...files, file]);
      }
    }
  };

  //Remove image files from file list component
  const removeHandler = (filename) => {
    setFiles(files.filter((file) => file.name !== filename));
  };

  //Focus input elements
  const handleFocus = (e) => {
    setFocused(true);
  };

  //Get value form input elements and assign into values states
  const onChangeValue = (e) => {
    e.preventDefault();
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  // ***Here is code for converting "Base64" to javascript "File Object".***

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const convertAsImage = (url) => {
    const toDataURL = (url) =>
      fetch(url)
        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        );

    toDataURL(url).then((dataUrl) => {
      try {
        const parts = url.split("/"); // safer for URLs
        const filename = parts[parts.length - 1];
        const [nameImage, ext] = filename.split(".");

        const fileData = dataURLtoFile(dataUrl, `${nameImage}.${ext}`);
        setFiles([fileData]);
      } catch (error) {
        console.error("Error converting image URL to File:", error);
      }
    });
  };

  useEffect(() => {
    if (supplierId > 0) {
      setBtnName("Update");
      setId(supplierId);
      var today = new Date();
      var dob = new Date(supplierDetail.dob);

      setValues({
        first_name: supplierDetail.first_name ? supplierDetail.first_name : "",
        last_name: supplierDetail.last_name ? supplierDetail.last_name : "",
        contact_no: supplierDetail.contact_no ? supplierDetail.contact_no : "",
        dob: supplierDetail.dob ? dob.toISOString().substring(0, 10) : today.toISOString().substring(0, 10),
        nic: supplierDetail.nic ? supplierDetail.nic : "",
        email: supplierDetail.email ? supplierDetail.email : "",
        address1: supplierDetail.address1 ? supplierDetail.address1 : "",
        address2: supplierDetail.address2 ? supplierDetail.address2 : "",
        address3: supplierDetail.address3 ? supplierDetail.address3 : "",
        village: supplierDetail.village ? supplierDetail.village : "",
        city: supplierDetail.city ? supplierDetail.city : "",
        country: supplierDetail.country ? supplierDetail.country : "",
        bank_name: supplierDetail.bank_details && supplierDetail.bank_details.length > 0 ? supplierDetail.bank_details[0].name : "",
        account_type: supplierDetail.bank_details && supplierDetail.bank_details.length > 0 ? supplierDetail.bank_details[0].account_type : "",
        bank_no: supplierDetail.bank_details && supplierDetail.bank_details.length > 0 ? supplierDetail.bank_details[0].bank_no : "",
      });

      const imgUrl = supplierDetail.upload_image ? api + "/" + supplierDetail.upload_image.image_url : {};
      if (Object.keys(imgUrl).length != 0) {
        convertAsImage(imgUrl);
      }
    }
  }, [id, supplierId, supplierDetail, users]);

  const submitForm = (e) => {
    e.preventDefault();

    const form = new FormData();
    form.append("first_name", values.first_name);
    form.append("last_name", values.last_name);
    form.append("contact_no", values.contact_no);
    form.append("dob", values.dob);
    form.append("nic", values.nic);
    form.append("email", values.email);
    form.append("address1", values.address1);
    form.append("address2", values.address2);
    form.append("address3", values.address3);
    form.append("village", values.village);
    form.append("city", values.city);
    form.append("country", values.country);
    form.append("updatedBy", signInUser.id);
    form.append("uploaded_file", files[0]);
    const bank_data = {
      bank_name: values.bank_name,
      account_type: values.account_type,
      bank_no: values.bank_no,
    };

    form.append("bank", JSON.stringify(bank_data));

    //User Form Data
    var userFormData = new FormData();
    userFormData.append("first_name", values.first_name);
    userFormData.append("last_name", values.last_name);
    userFormData.append("nic", values.nic);
    userFormData.append("contact_no", values.contact_no);
    userFormData.append("email", values.email);
    userFormData.append("status", "Active");
    userFormData.append("password", values.password);
    userFormData.append("roleId", 4);
    userFormData.append("uploaded_file", files[0]);

    if (supplierId > 0) {
      updateSupplier(supplierId, form, (res) => {
        const userData = users.data.filter((user) => {
          return user.nic === supplierDetail.nic;
        });

        if (userData[0].id > 0) {
          const userId = userData[0].id;
          updateUser(userId, userFormData, (response) => {
            if (response.status === 200) {
              toast.success(res.data);
              setCallback(!callback);
            } else {
              toast.error(res.data);
              setCallback(!callback);
            }
          }).catch((err) => {
            console.log("Update user error : ", err);
          });
        } else {
          toast.error(res.data);
          setCallback(!callback);
        }
      });
    } else {
      form.append("createdBy", signInUser.id);
      createNewSupplier(form, (res) => {
        userFormData.append("supplier_id", res.supplier.id);
        if (res.status === 200) {
          createNewUser(userFormData, (response) => {
            if (response.status === 200) {
              toast.success(response.data);
              setCallback(!callback);
            } else {
              toast.error(response.data);
              setCallback(!callback);
            }
          });
        } else {
          toast.error(res.data);
          setCallback(!callback);
        }
      });
    }
  };

  return !supplierDetail ? (
    <div className="form-container">
      <div className="loading-page-container">
        <Loading />
      </div>
    </div>
  ) : (
    <div className="form-container">
      <header>{supplierId > 0 ? "Update Supplier Form" : "Update Supplier Form"}</header>
      <form onSubmit={submitForm} className="form">
        <FileUpload uploadHandler={uploadHandler} />
        <FileList files={files} removeHandler={removeHandler} />

        <div className="input-box">
          <label htmlFor="first_name">First Name</label>
          <input
            type="text"
            name="first_name"
            id="first_name"
            placeholder="Enter First Name"
            value={values.first_name || ""}
            required
            pattern="^[A-Za-z0-9 ,]{3,}$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>First name should be above 3 characters and shouldn't any spacial character</span>
        </div>

        <div className="input-box">
          <label htmlFor="last_name">Last Name</label>
          <input
            type="text"
            name="last_name"
            id="last_name"
            placeholder="Enter Last Name"
            value={values.last_name || ""}
            required
            pattern="^[A-Za-z0-9 ,]{3,}$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>Last name should be above 3 characters and shouldn't any spacial character</span>
        </div>

        <div className="input-box">
          <label htmlFor="contact_no">Contact No</label>
          <input
            type="text"
            name="contact_no"
            id="contact_no"
            placeholder="Enter Contact No"
            value={values.contact_no || ""}
            required
            pattern="^(?:\+94|0)?(7[01245678]\d{7}|(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|91)[2-9]\d{6})$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>Invalid contact number</span>
        </div>

        <div className="input-box">
          <label htmlFor="dob">Date of Birth</label>
          <input type="date" name="dob" id="dob" value={values.dob || new Date().toISOString().substring(0, 10)} placeholder="Enter Contact Number" required onChange={onChangeValue} />
        </div>

        <div className="input-box">
          <label htmlFor="nic">NIC</label>
          <input
            type="text"
            name="nic"
            id="nic"
            placeholder="Enter NIC"
            value={values.nic || ""}
            required
            pattern="^(?:\d{9}[VXvx]|\d{12})$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>Invalid NIC number</span>
        </div>

        <div className="input-box">
          <label htmlFor="email">Email</label>
          <input
            type="text"
            name="email"
            id="email"
            placeholder="Enter Email"
            value={values.email || ""}
            required
            pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
          <span>Invalid email address</span>
        </div>

        {supplierId > 0 ? (
          <></>
        ) : (
          <div>
            <div className="input-box">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                required
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$"
                onBlur={handleFocus}
                focused={focused.toString()}
                onChange={onChangeValue}
              />
              <span>Password should be 8-16 characters and include at least 1 letter and 1 special character!</span>
            </div>

            <div className="input-box">
              <label htmlFor="confirm_password">Confirm Password</label>
              <input type="password" name="confirm_password" id="confirm_password" required pattern={values.password} onBlur={handleFocus} focused={focused.toString()} onChange={onChangeValue} />
              <span>Password don't match!</span>
            </div>
          </div>
        )}

        <div className="input-box address">
          <label>Address</label>
          <input type="text" name="address1" id="address1" placeholder="Enter Address1" value={values.address1 || ""} onChange={onChangeValue} />
          <input type="text" name="address2" id="address2" placeholder="Enter Address2" value={values.address2 || ""} onChange={onChangeValue} />
          <input type="text" name="address3" id="address3" placeholder="Enter Address3" value={values.address3 || ""} onChange={onChangeValue} />
          <input type="text" name="village" id="village" placeholder="Enter Village" value={values.village || ""} onChange={onChangeValue} />
          <input type="text" name="city" id="city" placeholder="Enter City" value={values.city || ""} onChange={onChangeValue} />
          <input type="text" name="country" id="country" placeholder="Enter Country" value={values.country || ""} onChange={onChangeValue} />
        </div>

        <div className="input-box address">
          <label>Bank Details</label>
          <input type="text" name="bank_name" id="bank_name" placeholder="Enter Bank Name" value={values.bank_name || ""} onChange={onChangeValue} />
          <input type="text" name="account_type" id="account_type" placeholder="Enter Account Type" value={values.account_type || ""} onChange={onChangeValue} />
          <input type="text" name="bank_no" id="bank_no" placeholder="Enter Bank Number" value={values.bank_no || ""} onChange={onChangeValue} />
        </div>

        <div className="form-button">
          <button className="add_new">{btnName}</button>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
}
